<template>
  <v-card class="v-modal-new-window analyzed-dialog analyzed-view-dialog v-dialog-1">
    <v-card-title class="headline white--text" primary-title>
      {{ title }}
    </v-card-title>
    <template>
      <system-progress :sysloadingTitle="sysloadingTitle" :sysloading="isLoading"></system-progress>
      <v-card-text class="comm-custom-boder user-data-section">
        <v-tabs v-if="item.action == 'copy'" v-model="selectTab" vertical class="comm-custom-mq">
          <v-tab :disabled="checkFTPs" class="tab-text" href="#FTPS">
            <v-icon small left>fa fa-folder-open</v-icon>
            {{ $t('lbl.communications.ftps') }}
          </v-tab>
          <v-tab :disabled="checkSFTP" class="tab-text" href="#SFTP">
            <v-icon small left>fa fa-folder-open</v-icon>
            <span style="text-transform: lowercase">s</span>
            {{ $t('lbl.communications.ftp') }}
          </v-tab>
          <v-tab :disabled="checkSMTP" class="tab-text" href="#SMTP">
            <v-icon small left>far fa-envelope</v-icon>
            {{ $t('lbl.communications.smtp') }}
          </v-tab>
          <v-tab :disabled="checkIMAP" class="tab-text" href="#IMAP">
            <v-icon small left>far fa-envelope</v-icon>
            {{ $t('lbl.communications.imap') }}
          </v-tab>
          <v-tab :disabled="checkPOP3" class="tab-text" href="#POP3">
            <v-icon small left>far fa-envelope</v-icon>
            {{ $t('lbl.communications.pop3') }}
          </v-tab>
          <v-tab :disabled="checkAPI" class="tab-text" href="#API">
            <v-icon small left>fa fa-globe-americas</v-icon>
            {{ $t('lbl.communications.restApi') }}
          </v-tab>
          <v-tab :disabled="checkMQ" class="tab-text" href="#MQ">
            <v-icon small left>fab fa-buffer</v-icon>
            {{ $t('lbl.communications.mq') }}
          </v-tab>
          <v-tab :disabled="checkSOAP" class="tab-text" href="#SOAP">
            <v-icon small left>fa fa-globe-americas</v-icon>
            {{ $t('lbl.communications.soapApi') }}
          </v-tab>
          <v-tab :disabled="checkHTTP" class="tab-text" href="#HTTP">
            <v-icon small left>fa fa-globe-americas</v-icon>
            {{ $t('lbl.communications.http') }}
          </v-tab>
          <!-- No transition affect when change tab  -->
          <v-tab-item value="FTPS" :transition="false" :reverse-transition="false">
            <FTPS :item="item" ref="FTPS" />
          </v-tab-item>
          <v-tab-item value="SFTP" :transition="false" :reverse-transition="false">
            <SFTP :item="item" ref="SFTP" />
          </v-tab-item>
          <v-tab-item value="SMTP" :transition="false" :reverse-transition="false">
            <SMTP :item="item" ref="SMTP" />
          </v-tab-item>
          <v-tab-item value="IMAP" :transition="false" :reverse-transition="false">
            <IMAP :item="item" ref="IMAP" />
          </v-tab-item>
          <v-tab-item value="POP3" :transition="false" :reverse-transition="false">
            <POP3 :item="item" ref="POP3" />
          </v-tab-item>
          <v-tab-item value="API" :transition="false" :reverse-transition="false">
            <REST-API :item="item" ref="API" />
          </v-tab-item>
          <v-tab-item value="MQ" :transition="false" :reverse-transition="false">
            <MQ :item="item" ref="MQ" />
          </v-tab-item>
          <v-tab-item value="SOAP" :transition="false" :reverse-transition="false">
            <SOAP-API :item="item" ref="SOAP" />
          </v-tab-item>
          <v-tab-item value="HTTP" :transition="false" :reverse-transition="false">
            <HTTP :item="item" ref="HTTP" />
          </v-tab-item>
        </v-tabs>
        <v-tabs v-if="item.action != 'copy'" v-model="selectTab" vertical class="comm-custom-mq">
          <v-tab
            :disabled="(item.action == 'edit' && selectTab != 'FTPS') || !$auth.manage"
            class="tab-text"
            href="#FTPS"
          >
            <v-icon small left>fa fa-folder-open</v-icon>
            {{ $t('lbl.communications.ftps') }}
          </v-tab>
          <v-tab
            :disabled="(item.action == 'edit' && selectTab != 'SFTP') || !$auth.manage"
            class="tab-text"
            href="#SFTP"
          >
            <v-icon small left>fa fa-folder-open</v-icon>
            <span style="text-transform: lowercase">s</span>
            {{ $t('lbl.communications.ftp') }}
          </v-tab>
          <v-tab
            :disabled="(item.action == 'edit' && selectTab != 'SMTP') || !$auth.manage"
            class="tab-text"
            href="#SMTP"
          >
            <v-icon small left>far fa-envelope</v-icon>
            {{ $t('lbl.communications.smtp') }}
          </v-tab>
          <v-tab
            :disabled="(item.action == 'edit' && selectTab != 'IMAP') || !$auth.manage"
            class="tab-text"
            href="#IMAP"
          >
            <v-icon small left>far fa-envelope</v-icon>
            {{ $t('lbl.communications.imap') }}
          </v-tab>
          <v-tab
            :disabled="(item.action == 'edit' && selectTab != 'POP3') || !$auth.manage"
            class="tab-text"
            href="#POP3"
          >
            <v-icon small left>far fa-envelope</v-icon>
            {{ $t('lbl.communications.pop3') }}
          </v-tab>
          <v-tab
            :disabled="(item.action == 'edit' && selectTab != 'API') || !$auth.manage"
            class="tab-text"
            href="#API"
          >
            <v-icon small left>fa fa-globe-americas</v-icon>
            {{ $t('lbl.communications.restApi') }}
          </v-tab>
          <v-tab
            :disabled="(item.action == 'edit' && selectTab != 'MQ') || !$auth.manage"
            class="tab-text"
            href="#MQ"
          >
            <v-icon small left>fab fa-buffer</v-icon>
            {{ $t('lbl.communications.mq') }}
          </v-tab>
          <v-tab
            :disabled="(item.action == 'edit' && selectTab != 'SOAP') || !$auth.manage"
            class="tab-text"
            href="#SOAP"
          >
            <v-icon small left>fa fa-globe-americas</v-icon>
            {{ $t('lbl.communications.soapApi') }}
          </v-tab>
          <v-tab
            :disabled="(item.action == 'edit' && selectTab != 'HTTP') || !$auth.manage"
            class="tab-text"
            href="#HTTP"
          >
            <v-icon small left>fa fa-globe-americas</v-icon>
            {{ $t('lbl.communications.http') }}
          </v-tab>
          <v-tab-item value="FTPS" :transition="false" :reverse-transition="false">
            <FTPS :item="item" ref="FTPS" />
          </v-tab-item>
          <v-tab-item value="SFTP" :transition="false" :reverse-transition="false">
            <SFTP :item="item" ref="SFTP" />
          </v-tab-item>
          <v-tab-item value="SMTP" :transition="false" :reverse-transition="false">
            <SMTP :item="item" ref="SMTP" />
          </v-tab-item>
          <v-tab-item value="IMAP" :transition="false" :reverse-transition="false">
            <IMAP :item="item" ref="IMAP" />
          </v-tab-item>
          <v-tab-item value="POP3" :transition="false" :reverse-transition="false">
            <POP3 :item="item" ref="POP3" />
          </v-tab-item>
          <v-tab-item value="API" :transition="false" :reverse-transition="false">
            <REST-API :item="item" ref="API" />
          </v-tab-item>
          <v-tab-item value="MQ" :transition="false" :reverse-transition="false">
            <MQ :item="item" ref="MQ" />
          </v-tab-item>
          <v-tab-item value="SOAP" :transition="false" :reverse-transition="false">
            <SOAP-API :item="item" ref="SOAP" />
          </v-tab-item>
          <v-tab-item value="HTTP" :transition="false" :reverse-transition="false">
            <HTTP :item="item" ref="HTTP" />
          </v-tab-item>
        </v-tabs>
        <v-row class="ml-0 mr-0 merge-button-group">
          <v-col class="button-col action-col pa-0" lg="12">
            <div class="btn-form-control text-right">
              <v-divider class="mt-5 mb-3"></v-divider>
              <v-btn class="btn btn-delete" @click="closeWindow('btn-close')">
                {{ $t('btn.common.close') }}
              </v-btn>
              <v-btn
                class="btn btn-popup-search"
                color="primary"
                @click="save"
                :disabled="!$auth.manage"
              >
                {{ $t('btn.common.save') }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </template>
    <dialogWindow
      ref="AlertCommSetup"
      size="max"
      :detail="checkDialogInfo"
      :color="checkDialogColor"
      @select-ok="$refs.AlertCommSetup.dialog = false"
    >
    </dialogWindow>
  </v-card>
</template>

<script>
import FTPS from './FTPS';
import SFTP from './SFTP';
import IMAP from './IMAP';
import POP3 from './POP3';
import SMTP from './SMTP';
import REST_API from './REST-API';
import MQ from './MQ';
import SOAP_API from './SOAP-API';
import HTTP from './HTTP';
import { mapState } from 'vuex';
import SystemProgress from '@/vue-dlb/components/SystemProgress.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';

export default {
  components: {
    FTPS,
    SFTP,
    IMAP,
    POP3,
    SMTP,
    'REST-API': REST_API,
    MQ,
    'SOAP-API': SOAP_API,
    HTTP,
    SystemProgress,
    dialogWindow,
  },

  data: () => ({
    checkFTPs: true,
    checkSFTP: true,
    checkSMTP: true,
    checkIMAP: true,
    checkPOP3: true,
    checkAPI: true,
    checkMQ: true,
    checkSOAP: true,
    checkHTTP: true,
    item: {
      default: Object,
    },
    selectTab: {
      default: '',
    },
    currentTab: '',
    title: '',
    isLoading: false,
    checkDialogInfo: '',
    checkDialogColor: 'warning',
  }),
  created() {
    this.$auth.manage = true;
    if (window.theme) {
      this.$vuetify.theme.dark = true;
    } else {
      this.$vuetify.theme.dark = false;
    }
    let param = this.fileViewWindowParam[this.$route.params.id];
    (this.item = param['editedItem']),
      // 탭 선택값을 입력
      (this.selectTab =
        this.item.type == 'IBM_MQ' || this.item.type == 'ACTIVE_MQ'
          ? 'MQ'
          : this.item.type || 'FTPS');

    if (this.item.type == 'FTP') {
      this.selectTab = 'FTPS';
    }
    this.currentTab = this.selectTab;
    let action = this.item.action;
    this.title = this.item.formtitle;
    if (action == 'add' && typeof this.item.type != 'undefined') {
      delete this.item.type;
    }
    if (action == 'copy') {
      this.checkFTPs = true;
      this.checkSFTP = true;
      this.checkSMTP = true;
      this.checkIMAP == true;
      this.checkPOP3 = true;
      this.checkAPI = true;
      this.checkMQ = true;
      this.checkSOAP = true;
      this.checkHTTP = true;
      switch (this.selectTab) {
        case 'FTPS':
          this.checkFTPs = false;
          this.checkSFTP = false;
          break;
        case 'SFTP':
          this.checkFTPs = false;
          this.checkSFTP = false;
          break;
        case 'SMTP':
          this.checkSMTP = false;
          break;
        case 'IMAP':
          this.checkIMAP = false;
          this.checkPOP3 = false;
          break;
        case 'POP3':
          this.checkIMAP = false;
          this.checkPOP3 = false;
          break;
        case 'API':
          this.checkSMTP = false;
          break;
        case 'MQ':
          this.checkMQ = false;
          break;
        case 'SOAP':
          this.checkSOAP = false;
          break;
        case 'HTTP':
          this.checkHTTP = false;
          break;
      }
    }
  },
  computed: {
    ...mapState('analysis', {
      fileViewWindowParam: 'fileViewWindowParam',
    }),
    ...mapState('common', {
      sysloadingTitle: 'sysloadingTitle',
    }),
  },
  mounted() {
    setTimeout(() => {
      document.getElementsByClassName('overlay-background')[0].style.display = 'none';
    }, 1000);
  },
  //팝업이 열릴 때 마다 데이터를 바인딩하여 동적으로 동작하도록
  watch: {},
  methods: {
    async save() {
      this.isLoading = true;
      let saveParams = this.$refs[this.selectTab].formData;
      if (saveParams.name != '') {
        this.$refs[this.selectTab].setFieldValidation('name', '');
        await this.$store.dispatch('checkComm', saveParams);
        let listComm = this.$store.getters.validCommunicationList;
        if (listComm.length != 0) {
          let action = this.item.action;
          if (action == 'edit') {
            if (listComm.length === 1 && listComm[0].id != this.item.id) {
              this.checkDialogInfo = `Communication name : ${saveParams.name} have been created !`;
              this.checkDialogColor = 'warning';
              this.$refs.AlertCommSetup.dialog = true;
              this.isLoading = false;
              return false;
            }
          } else {
            this.checkDialogInfo = `Communication name : ${saveParams.name} have been created !`;
            this.checkDialogColor = 'warning';
            this.$refs.AlertCommSetup.dialog = true;
            this.isLoading = false;
            return false;
          }
        }
      }
      let validResult = this.$refs[this.selectTab].$refs.form.validate();
      switch (this.selectTab) {
        case 'FTPS':
          if (validResult) {
            let result = await this.$refs.FTPS.save(this.item.action);
            if (result !== -1) {
              this.closeWindow('btn-close');
            }
          }
          break;
        case 'SFTP':
          if (validResult) {
            let result = await this.$refs.SFTP.save(this.item.action);
            if (result !== -1) {
              this.closeWindow('btn-close');
            }
          }
          break;
        case 'IMAP':
          if (validResult) {
            let result = await this.$refs.IMAP.save(this.item.action);
            if (result !== -1) {
              this.closeWindow('btn-close');
            }
          }
          break;
        case 'SMTP':
          if (validResult) {
            let result = await this.$refs.SMTP.save(this.item.action);
            if (result !== -1) {
              this.closeWindow('btn-close');
            }
          }
          break;
        case 'POP3':
          if (validResult) {
            let result = await this.$refs.POP3.save(this.item.action);
            if (result !== -1) {
              this.closeWindow('btn-close');
            }
          }
          break;
        case 'API':
          if (validResult) {
            if (this.$refs[this.selectTab].$refs.callbacks) {
              if (this.$refs[this.selectTab].$refs.callbacks.validate()) {
                let result = await this.$refs.API.save(this.item.action);
                if (result !== -1) {
                  this.closeWindow('btn-close');
                }
              }
            } else {
              let result = await this.$refs.API.save(this.item.action);
              if (result !== -1) {
                this.closeWindow('btn-close');
              }
            }
          }
          break;
        case 'MQ':
          if (validResult) {
            let result = await this.$refs.MQ.save(this.item.action);
            if (result !== -1) {
              this.closeWindow('btn-close');
            }
          }
          break;
        case 'SOAP':
          if (validResult) {
            if (this.$refs[this.selectTab].$refs.callbacks) {
              if (this.$refs[this.selectTab].$refs.callbacks.validate()) {
                let result = await this.$refs.SOAP.save(this.item.action);
                if (result !== -1) {
                  this.closeWindow('btn-close');
                }
              }
            } else {
              let result = await this.$refs.SOAP.save(this.item.action);
              if (result !== -1) {
                this.closeWindow('btn-close');
              }
            }
          }
          break;
        case 'HTTP':
          if (validResult) {
            let result = await this.$refs.HTTP.save(this.item.action);
            if (result !== -1) {
              this.closeWindow('btn-close');
            }
          }
          break;
        default:
          break;
      }
      this.isLoading = false;
      return validResult;
    },
    closeWindow(type) {
      const message = {
        message: type,
      };
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage(message, '*');
      }

      setTimeout(() => {
        window.close();
      }, 50);
    },
  },
};
</script>

<style>
div.confirm-dialog-container {
  display: none;
}
.comm-custom-boder .v-text-field {
  margin-top: 6px;
}
.comm-custom-mq > .v-window.v-item-group.v-tabs-items {
  height: 610px !important;
}
.v-dialog-1 .v-text-field > .v-input__control > .v-input__slot {
  height: 40px !important;
}
.comm-custom-mq .v-icon.v-icon--dense.mdi-plus,
.oauth-minus {
  margin-top: 5px;
  height: 40px;
  width: 40px;
  background-color: #3e424e;
}
.comm-custom-mq .v-icon.v-icon::after {
  background-color: transparent !important;
}
.comm-custom-mq .mdi-eye::before,
.mdi-eye-off::before {
  margin-right: 16px;
}
.comm-custom-mq form.v-form label {
  font-weight: 600;
  font-size: 13px;
  line-height: 18px;
}
.comm-custom-mq .v-tab--active .v-icon {
  color: inherit !important;
}
</style>
